import { render, staticRenderFns } from "./FlashToast.vue?vue&type=template&id=3c85a180"
import script from "./FlashToast.vue?vue&type=script&lang=js"
export * from "./FlashToast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports